import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useImageNotLoaded } from '@sbt-web/hooks';
import type { PresenceStatus } from '@sbt-web/network/types';
import styles from './index.module.scss';
export enum PrivateUserBadgeSize {
  Normal = 'normal',
  Small = 'small',
}
interface Props {
  name: string;
  url: string;
  handleClick: () => void;
  size?: PrivateUserBadgeSize;
  picture?: string;
  presenceStatus?: PresenceStatus;
}
interface LetterBadgeProps {
  name: string;
}
const LetterBadge = t0 => {
  const $ = _c(4);
  const {
    name
  } = t0;
  let t1;
  if ($[0] !== name[0]) {
    t1 = name[0]?.toUpperCase() || "";
    $[0] = name[0];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="button-text small">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const UserBadge = t0 => {
  const $ = _c(15);
  const {
    name,
    url,
    handleClick,
    size: t1,
    picture,
    presenceStatus
  } = t0;
  const size = t1 === undefined ? PrivateUserBadgeSize.Normal : t1;
  const imageNotLoaded = useImageNotLoaded(picture ?? "");
  const t2 = `Vai al profilo di ${name}`;
  const t3 = size === PrivateUserBadgeSize.Small;
  let t4;
  if ($[0] !== t3) {
    t4 = classNames(styles.rounded_user_badge, {
      [styles.small]: t3
    });
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== imageNotLoaded || $[3] !== name || $[4] !== picture) {
    t5 = imageNotLoaded || !picture ? <LetterBadge name={name} /> : <img alt={name} className={styles.picture} src={picture} />;
    $[2] = imageNotLoaded;
    $[3] = name;
    $[4] = picture;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== presenceStatus) {
    t6 = presenceStatus === "ONLINE" && <span className={styles.presence_online_status} aria-label="Online ora" />;
    $[6] = presenceStatus;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== handleClick || $[9] !== t2 || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== url) {
    t7 = <a href={url} title={t2} onClick={handleClick} className={t4}>{t5}{t6}</a>;
    $[8] = handleClick;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = url;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};